// @ts-nocheck
export const localeCodes =  [
  "tr",
  "en"
]
export const localeLoaders = {
  tr: [
    {
      key: "locale_tr_46json_cba1a277",
      load: () => import("#nuxt-i18n/cba1a277" /* webpackChunkName: "locale_tr_46json_cba1a277" */),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_46json_76ef8785",
      load: () => import("#nuxt-i18n/76ef8785" /* webpackChunkName: "locale_en_46json_76ef8785" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = [
  () => import("#nuxt-i18n/db048695" /* webpackChunkName: "config_i18n_46config_46ts_db048695" */)
]
export const normalizedLocales = [
  {
    code: "tr",
    iso: "tr-TR",
    name: "Türkçe",
    language: "tr-TR",
    _hreflang: "tr-TR",
    _sitemap: "tr-TR"
  },
  {
    code: "en",
    iso: "en-US",
    name: "English",
    language: "en-US",
    _hreflang: "en-US",
    _sitemap: "en-US"
  }
]
/** client **/

/** client-end **/